module.exports = __webpack_public_path__ + "0608aff97a22232aba37b776cdd90f5c.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/labels/eyes-bold.svg
// module id = JIDL
// module chunks = 0